import { useTheme } from '@mui/material/styles';
import { LinearProgress } from '@mui/material';

const LinearProgressbar = () => {
  const theme = useTheme();
  return (
    <div
      style={{ backgroundColor: theme.palette.background.default }}
      className="w-[90%] mx-auto h-full fixed top-0 left-1/2 -translate-x-1/2 flex justify-center items-center"
    >
      <div className="w-[60%] sm:w-[50%] md:w-[40%] lg:w-[25%]">
        <LinearProgress color="primary" />
        {/* <LinearProgress color={theme.palette.mode === 'light' ? 'inherit' : 'primary'} /> */}
      </div>
    </div>
  );
};

export default LinearProgressbar;
